import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ReactiveSearch from "@appbaseio/reactivesearch-vue";
import Keycloak from "keycloak-js";
import axios from "axios";
import vuetify from "./plugins/vuetify";
import Sticky from "vue-sticky-directive";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
});

Vue.config.productionTip = false;

Vue.use(ReactiveSearch);
Vue.use(Sticky);

const tokenInterceptor = () => {
  axios.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KC_URL,
  realm: process.env.VUE_APP_KC_REALM,
  clientId: process.env.VUE_APP_KC_CLIENT_ID,
});

Vue.prototype.$keycloak = keycloak;

keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false })
  .then(() => {
    if (!keycloak.hasResourceRole("admin", process.env.VUE_APP_KC_CLIENT_ID)) {
      keycloak.logout();
      return;
    }
    tokenInterceptor();
    new Vue({
      router,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");

    setInterval(() => {
      keycloak.updateToken(30).catch(() => keycloak.login());
    }, 10000);
  });
